import "../../styles/credentials/credentialsMobile.scss";
import { VelocityCredentialTypes } from "wallet-elementkit/dist/translations";
import SingleCategory from "../../components/profile/SingleCategory/SingleCategory";
import ProfileNoData from "../../components/profile/ProfileNoData/ProfileNoData";

function CredentialsMobile(props) {
	const veloCityTypes = VelocityCredentialTypes;

	return props.certificates.length > 0 || props.badges.length > 0 ? (
		<div id="profile-credentials-mobile" className="flex-column">
			<div className="category-grid">
				{props.certificates.length ? (
					<SingleCategory
						category={"5"}
						count={props.certificates.length}
						title={veloCityTypes[props.activeLanguage.code]["5"]}
						key={`category-credentials-certificates`}
						isMobile={true}
						onClickAction={() => props.goToCredentials("5")}
						addTranslation={props.addTranslation}
						activeLanguageCode={props.activeLanguage?.code ?? "en"}
					/>
				) : null}
				{props.badges.length ? (
					<SingleCategory
						category={"4"}
						title={veloCityTypes[props.activeLanguage.code]["4"]}
						count={props.badges.length}
						key={`category-credentials-badges`}
						isMobile={true}
						onClickAction={() => props.goToCredentials("4")}
						addTranslation={props.addTranslation}
						activeLanguageCode={props.activeLanguage?.code ?? "en"}
					/>
				) : null}
			</div>
		</div>
	) : (
		<ProfileNoData noDataText={props.noDataText} />
	);
}
export default CredentialsMobile;
